module.exports = __webpack_public_path__ + "img/navigate_to_test.2d026e49.png";